import { Mediator, app, payload } from "modular-openscriptjs";
import { eParse } from "../helpers";

const $e = app("$e");

export class LocationMediator extends Mediator {
	$$location = {
		is: {
			needed: (ed, event) => this.send($e.map.needs.interface, ed),
		},
		needs: {
			decode: (ed, event) => this.geoDecode(ed, event),
		},
	};

	$$map = {
		has: {
			location: (ed, event) => this.send($e.location.is.available, ed),
		},
	};

	async geoDecode(ed, event) {
		await google.maps.importLibrary("maps");

		const data = eParse(ed);

		const latLng = {
			lat: parseFloat(data.message.get("latitude")),
			lng: parseFloat(data.message.get("longitude")),
		};

		let geocoder = new google.maps.Geocoder();
		geocoder.geocode({ location: latLng }, (results, status) => {
			if (status === "OK") {
				if (results[0]) {
					const placeInfo = results[0];

					let p = {
						address: placeInfo.formatted_address,
						latitude: latLng.lat,
						longitude: latLng.lng,
					};

					let m = data.meta;

					this.send($e.location.is.decoded, payload(p, m));
				} else {
					this.send($e.location.has.decodeError, ed);
				}
			}
		});
	}
}
